
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_1ku9a_153",
  "button": "awsui_button_vjswe_1ku9a_157",
  "variant-normal": "awsui_variant-normal_vjswe_1ku9a_205",
  "disabled": "awsui_disabled_vjswe_1ku9a_223",
  "variant-primary": "awsui_variant-primary_vjswe_1ku9a_230",
  "variant-link": "awsui_variant-link_vjswe_1ku9a_255",
  "variant-icon": "awsui_variant-icon_vjswe_1ku9a_280",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_1ku9a_305",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_1ku9a_330",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_1ku9a_359",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_1ku9a_384",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_1ku9a_409",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_1ku9a_439",
  "button-no-text": "awsui_button-no-text_vjswe_1ku9a_531",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_1ku9a_535",
  "full-width": "awsui_full-width_vjswe_1ku9a_538",
  "icon-left": "awsui_icon-left_vjswe_1ku9a_557",
  "icon-right": "awsui_icon-right_vjswe_1ku9a_562",
  "icon": "awsui_icon_vjswe_1ku9a_557",
  "link": "awsui_link_vjswe_1ku9a_581",
  "disabled-with-reason": "awsui_disabled-with-reason_vjswe_1ku9a_581"
};
  